import { AbstractControl } from '@angular/forms';

/** Removes every whitespace character, including leading and trailing spaces. */
export function stripEmailSpaces(value: string | null | undefined): string {
	if (value == null) {
		return '';
	}
	return value.replace(/\s/g, '');
}

/** Writes the space-free value back on the control when it still contains whitespace. */
export function normalizeEmailControl(control: AbstractControl | null | undefined): void {
	if (!control || typeof control.value !== 'string') {
		return;
	}
	const cleaned = stripEmailSpaces(control.value);
	if (cleaned !== control.value) {
		control.setValue(cleaned);
	}
}
